import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { filter, map, switchMap, tap } from 'rxjs';
import { DataService } from 'src/core/services/data.service';
import { DaterangeService } from 'src/core/services/daterange.service';
import { DeviceService } from 'src/core/services/device.service';
import { LoadingService } from 'src/core/services/loading.service';
import { ModalService } from 'src/core/services/modal.service';
import { SelectedContentService } from 'src/core/services/selectedcontent.service';
import { SelectedSiteService } from 'src/core/services/selectedsite.service';
import { SelectedsystemService } from 'src/core/services/selectedsystem.service';
import { WidgetService } from 'src/core/services/widget.service';
import { SelectedSite } from 'src/core/types/selectedSite.types';
import { UpcomingServices } from 'src/core/types/servicehistory.types';

@Component({
  selector: 'app-upcoming-activities',
  imports: [CommonModule, TranslocoModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './upcoming-activities.component.html',
  styleUrls: ['./upcoming-activities.component.css']
})
export class UpcomingActivitiesComponent {

  @Input() type: 'device' | 'site' = 'device';
  getDeviceType = this.deviceService.getDeviceType;
  upcomingservices: UpcomingServices;
  isLoading: boolean = true;
  isError: boolean;
  isEmpty: boolean;
  selectedSite: SelectedSite;
  constructor(private daterangeService: DaterangeService, private widgetService: WidgetService, private deviceService: DeviceService, private dataService: DataService, private selectedSystemService: SelectedsystemService, private loadingService: LoadingService, private selectedContentService: SelectedContentService, private modalService: ModalService) { 

  }

  selectedRange;

  get hasAnyPending(): boolean {
    if (!this.upcomingservices) return false;
    return (this.upcomingservices.outstanding_mu !== 0 && this.upcomingservices.outstanding_mu !== null)
      || (this.upcomingservices.outstanding_pm !== 0 && this.upcomingservices.outstanding_pm !== null)
      || (this.upcomingservices.upcoming_psm !== 0 && this.upcomingservices.upcoming_psm !== null);
  }

  ngOnInit(): void {
    this.loadingService.$isUpcomingServicesLoading.subscribe((isUpcomingServicesLoading) => {
      this.isLoading = isUpcomingServicesLoading;
    });
    this.loadingService.$isUpcomingServicesError.subscribe((isError) => {
      this.isError = isError;
    });
    this.loadingService.$isUpcomingServicesEmpty.subscribe((isEmpty) => {
      this.isEmpty = isEmpty;
    });
    this.daterangeService.$selectedRangeUpcomingServices.subscribe((selectedRange) => {
      this.selectedRange = selectedRange;
      console.log("Selected date range:", this.selectedRange);
    });

    this.selectedSystemService.$upcomingservices.subscribe((upcomingservices) => {
      this.upcomingservices = upcomingservices;
    });
  }

   onMaximize(filter?: string) {
    if (this.widgetService.$workareaSize.value !== "small" && this.widgetService.$selectedWidget.value === "upcoming-services" && !filter) {
      this.widgetService.closeWidget();
      return;
    }

    this.widgetService.expandWidget("upcoming-services", filter);
  }
  
  changeRange(range) {
    this.daterangeService.$selectedRangeUpcomingServices.next(range);
  }

  checkWidgetIcon() {
    if (this.widgetService.$workareaSize.value !== "small" && this.widgetService.$selectedWidget.value === "upcoming-services") {
      return "minus";
    } else {
      return "plus";
    }
  }
  

  openHelp(section) {
    this.modalService.$helpModalChanged.next({ modal: section, open: true });
  }
}
